export const getEmailChangeInitialValues = () => ({
    participantNumber: '',
    email: '',
    reason: { label: '', value: '' },
});
// The code is what routes/participant/update_email records in the participant's audit trail
// (c_change_reason_code -> audit.message). Axon accepts exactly these three (EMAIL_CHANGE_REASON_CODES in
// library.c_axon_participant_update_email.js) and renders them through its axon:emailChangeReasonCodes
// bundle, the same shape participant deactivation uses (CMP, SF, ...).
export const getEmailChangeReasons = (translate) => [
    {
        label: translate('label.participant_email_change.reason_incorrect_email'),
        value: 'IEE',
    },
    {
        label: translate('label.participant_email_change.reason_participant_request'),
        value: 'PRC',
    },
    {
        label: translate('label.participant_email_change.reason_email_inaccessible'),
        value: 'ENA',
    },
];
const normalizeEmail = (email) => (email ?? '').trim().toLowerCase();
export const isSameEmail = (email, currentEmail) => {
    const normalized = normalizeEmail(email);
    return normalized !== '' && normalized === normalizeEmail(currentEmail);
};
